import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import {useApolloClient} from '@apollo/client';

import { 
  fetchOneDomainInstance,
  OperationTargets
} from '../../api/CommonCrudOperations'

import LTRDomainObjectInfo from '../shared/domains/LTRDomainObjectInfo';

// Our labels in the Info Table
const labels = {
  type: "TYPE",
  company: "COMPANY",
  billType: "TYPE OF BILL",
  billingFrequency: "BILL FREQUENCY",
  howPaid: "HOW PAID",
  notes: "NOTES"
}

export const prepareTableRowInfo = (subscription) => {
  // prepare table data for show
  let messageAction = '';
  let messageDoc = '';
  if (subscription.actionItems) {
    messageAction = subscription.actionItems.length === 0 ? "This subscription has NO action items" :
    "This subscription has " + subscription.actionItems.length + " action items";
  }
  if (subscription.attachments) {
    messageDoc = subscription.attachments.length === 0 ? "This subscription has NO attached files":
    "This subscription has " + subscription.attachments.length + " attached files"
  }
  
  const tableInfo = {
    name: subscription.name,
    actionItemMessage: messageAction,
    documentsMessage: messageDoc,
    fieldData : [
      {
        field: labels.type,
        value: subscription.type
      },
      {
        field: labels.company,
        value: subscription.company
      }
    ]     
  }
  let billerData;
  if (subscription.billers && subscription.billers.length > 0) {
    const biller = subscription.billers[0];    
    billerData = [
      {
        field: labels.billType,
        value: biller.billType
      },
      {
        field: labels.howPaid,
        value: biller.howPaid
      },
      {
        field: labels.billingFrequency,
        value: biller.billingFrequency
      },  
    ] 
  } else {
    billerData = billerData = [
      {
        field: labels.billType,
        value: ''
      },
      {
        field: labels.howPaid,
        value: ''
      },
      
      {
        field: labels.billingFrequency,
        value: ''
      },  
    ]
  }
  // add the biller data
  tableInfo.fieldData = tableInfo.fieldData.concat(billerData);
  
  // finally, notes
  const notesData = {
    field: labels.notes,
    value: subscription.notes
  }

  tableInfo.fieldData.push(notesData);

  return tableInfo;  
}

const useSubscriptionFetch = (client, domainId, updateFn) => {
  const [subscription, setSubscription] = useState(null);
  
  useEffect(() => {
    const fetchSubscription = () => { 
      fetchOneDomainInstance(client, OperationTargets.Subscriptions, domainId)
      .then(result => { 
        const subscription = result.item;
        setSubscription(subscription);
        updateFn(subscription);
      })
      .catch(error => {
        console.log(error) 
      });
    }

    if (subscription === null && domainId !== null) {
      fetchSubscription()
    }  
  }, [client, domainId, updateFn]);
};

const SubscriptionInfo = (props) => {
  const client = useApolloClient();

  const [showInfoDialogOpen, setShowInfoDialogOpen] = useState(false);
  const [tableInfo, setTableInfo] = useState(null);
  const [subscription, setSubscription] = useState(null);

  const handleShowInfoClose = () => {
    setShowInfoDialogOpen(false);
    // notify the client
    props.handleClose();
  }

  useSubscriptionFetch(client, props.domainId, (fetchedData) => {
    if (fetchedData !== null) {
      setSubscription(fetchedData);
      const info = prepareTableRowInfo(fetchedData);
      setTableInfo(info);
      setShowInfoDialogOpen(true);
    }
  });

  if (tableInfo === null) {
    return null;
  }

  return (
    <React.Fragment>  
      {showInfoDialogOpen ? (
        <LTRDomainObjectInfo
          open = {props.open}
          title = {subscription.name}
          tableData = {tableInfo}
          handleClose = {handleShowInfoClose}
        />): null
      }
    </React.Fragment>
  )
}

SubscriptionInfo.propTypes = {
  open: PropTypes.bool.isRequired,
  domainId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default (SubscriptionInfo);
